import React from 'react'
import logo from '../../assets/logo.jpg'
import './Foot.css'
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { Grid } from '@mui/material';
const Foot = () => {
  return (
    <>
      <div style={{ backgroundColor: '#101010' }}>
        <Grid className='Foot-container' container spacing={2}>
          <Grid className='foot-left' item sm={6}>
            <div>
              <div className="logo-title">
                <img src={logo} alt="" />
              </div>
              <div className="social-media">
                <InstagramIcon style={{ fontSize: 32 }} className='Sicon'></InstagramIcon>
                <a href="https://www.linkedin.com/company/chaitanyaai/" target='_blank'><LinkedInIcon style={{ fontSize: 32 }} className='Sicon'></LinkedInIcon></a>
                <TwitterIcon style={{ fontSize: 32 }} className='Sicon'></TwitterIcon>
              </div>
            </div>
          </Grid>
          <Grid className='foot-right' item sm={6}>
            <div className="contact-info">
              <span className='contact-title'>Contact Us</span>
              <a style={{ color: 'white',textDecoration:'none',marginTop:10}} href="mailto:chaitanyaaiconnect@gmail.com">
                <span style={{ fontSize: 16}}>chaitanyaaiconnect@gmail.com</span>
              </a>
            </div>
          </Grid>
        </Grid>
        <div className='hr-view'>
          <hr />
        </div>
        <div className="copyright">
          <div className="text">
            <CopyrightIcon style={{ color: 'white' }}></CopyrightIcon>
            <span style={{ color: 'white' }}>Copyright <span className='Company-name'>Chaitanya AI</span> Private Limited.All Rights Reserved</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default Foot